import {
    SET_HOME_BOOKMARK,
    SET_SELECTED_BOOKMARK,
    TOGGLE_HOME_BOOKMARK_REQUEST,
    TOGGLE_HOME_BOOKMARK_SUCCESS,
    TOGGLE_HOME_BOOKMARK_FAILURE,
    FETCH_HOME_BOOKMARK_REQUEST,
    FETCH_HOME_BOOKMARK_SUCCESS,
    FETCH_HOME_BOOKMARK_FAILURE,
    CREATE_BOOKMARK_SUCCESS
} from './Types';

import { commonDefaultState, commonHigherOrderReducer } from '../common/Reducer';
import { IBookmarkAction, IBookmarkReducerState } from './bookmarkTypes';

const defaultState = {
    bookmarks:[],
    homeBookmarkId: null,
    selectedBookmark: null,
    loading: false,
    ...commonDefaultState('bookmark', 'bookmarks')
};

export default function reducer (state: IBookmarkReducerState = defaultState, action:IBookmarkAction) {
    switch (action.type) {
        case SET_HOME_BOOKMARK:
            return {
                ...state,
                homeBookmarkId: action.id
            };
        case FETCH_HOME_BOOKMARK_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_HOME_BOOKMARK_SUCCESS:
            return {
                ...state,
                loading: false,
                homeBookmarkId: action.value
            };
        case FETCH_HOME_BOOKMARK_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case SET_SELECTED_BOOKMARK:
            return {
                ...state,
                selectedBookmark: action.value
            };
        case TOGGLE_HOME_BOOKMARK_REQUEST:
            return {
                ...state,
                homeBookmarkId: action.bookmark,
                loading: true
            };
        case TOGGLE_HOME_BOOKMARK_SUCCESS:
            return {
                ...state,
                homeBookmarkId: action.bookmark,
                loading: false
            };
        case TOGGLE_HOME_BOOKMARK_FAILURE:
            return {
                ...state,
                error: { status: action.error.status, statusText: action.error.statusText },
                loading: false
            };
        case CREATE_BOOKMARK_SUCCESS:
            return {
                ...state,
                isCreatingBookmark: false,
                bookmarks: [...state.bookmarks, action.bookmark],
                error: null,
                homeBookmarkId: action.bookmark.isHomeBookmark ? action.bookmark.id : state.homeBookmarkId
            };
        default:
            return commonHigherOrderReducer('bookmark', 'bookmarks')(state, action);
    }
}